<div class="preferences-container">
    <app-header-actions [config]="headerConfig" [headerTitle]="'SETTINGS.PREFERENCES.TITLE' | translate"
        [headerIcon]="faCog" (backClick)="goBack()" (customButtonClick)="onHeaderAction($event)"></app-header-actions>

    <div class="preferences-content" *ngIf="!loading; else loadingTemplate">
        <div class="preferences-card">
            <div class="card-header">
                <div class="header-text">
                    <h3>{{ 'SETTINGS.PREFERENCES.INTERACTION_OPTIONS' | translate }}</h3>
                    <p>{{ 'SETTINGS.PREFERENCES.DESCRIPTION' | translate }}</p>
                </div>
            </div>

            <div class="card-body">
                <div class="preference-item">
                    <div class="preference-info">
                        <span class="preference-label">{{ 'SETTINGS.PREFERENCES.SHOW_ADVANCED' | translate }}</span>
                        <span class="preference-description">{{ 'SETTINGS.PREFERENCES.SHOW_ADVANCED_DESC' | translate
                            }}</span>
                    </div>
                    <div class="preference-action">
                        <button class="toggle-btn" [class.active]="preferences.show_advanced_options"
                            (click)="preferences.show_advanced_options = !preferences.show_advanced_options">
                            <fa-icon [icon]="preferences.show_advanced_options ? faToggleOn : faToggleOff"></fa-icon>
                        </button>
                    </div>
                </div>

                <div class="divider"></div>

                <div class="preference-item">
                    <div class="preference-info">
                        <span class="preference-label">{{ 'SETTINGS.PREFERENCES.CLEAR_DELFOS_CACHE' | translate
                            }}</span>
                    </div>
                    <div class="preference-action">
                        <button class="toggle-btn" [class.active]="preferences.clear_delfos_cache"
                            (click)="preferences.clear_delfos_cache = !preferences.clear_delfos_cache">
                            <fa-icon [icon]="preferences.clear_delfos_cache ? faToggleOn : faToggleOff"></fa-icon>
                        </button>
                    </div>
                </div>

                <div class="preference-item" [class.disabled]="preferences.use_multimodal">
                    <div class="preference-info">
                        <span class="preference-label">{{ 'SETTINGS.PREFERENCES.CLEAR_OCR_CACHE' | translate }}</span>
                    </div>
                    <div class="preference-action">
                        <button class="toggle-btn" [class.active]="preferences.clear_di2winocr_cache"
                            [disabled]="preferences.use_multimodal"
                            (click)="preferences.clear_di2winocr_cache = !preferences.clear_di2winocr_cache">
                            <fa-icon [icon]="preferences.clear_di2winocr_cache ? faToggleOn : faToggleOff"></fa-icon>
                        </button>
                    </div>
                </div>

                <div class="preference-item">
                    <div class="preference-info">
                        <span class="preference-label">{{ 'SETTINGS.PREFERENCES.USE_MULTIMODAL' | translate }}</span>
                    </div>
                    <div class="preference-action">
                        <button class="toggle-btn" [class.active]="preferences.use_multimodal"
                            (click)="preferences.use_multimodal = !preferences.use_multimodal">
                            <fa-icon [icon]="preferences.use_multimodal ? faToggleOn : faToggleOff"></fa-icon>
                        </button>
                    </div>
                </div>

                <div class="divider"></div>

                <div class="preference-item">
                    <div class="preference-info">
                        <span class="preference-label">{{ 'SETTINGS.PREFERENCES.AI_MODEL_LANGUAGE' | translate }}</span>
                        <span class="preference-description">{{ 'SETTINGS.PREFERENCES.AI_MODEL_LANGUAGE_DESC' | translate }}</span>
                    </div>
                    <div class="preference-action">
                        <ng-select
                            [(ngModel)]="preferences.ai_model_language"
                            [items]="aiModelLanguageOptions"
                            bindLabel="label"
                            bindValue="value"
                            [appendTo]="'body'"
                            [clearable]="false"
                            [searchable]="false"
                            [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                            class="form-select language-select">
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.label | translate }}
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                {{ item.label | translate }}
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
            </div>
        </div>

        <div class="preferences-card" *ngIf="hasMultipleConfigs()">
            <div class="card-header">
                <div class="header-text">
                    <h3>{{ 'SETTINGS.PREFERENCES.DEFAULT_CONFIGS' | translate }}</h3>
                    <p>{{ 'SETTINGS.PREFERENCES.DEFAULT_CONFIGS_DESC' | translate }}</p>
                </div>
            </div>

            <div class="card-body">
                <div class="configs-grid">
                    <div class="config-field" *ngIf="showConfig('delfos_server')">
                        <label>{{ 'SETTINGS.PREFERENCES.DELFOS_SERVER' | translate }}</label>
                        <ng-select
                            [(ngModel)]="preferences.default_delfos_server_config_id"
                            [items]="delfosServerConfigs"
                            bindLabel="display_label"
                            bindValue="id"
                            [placeholder]="'SETTINGS.PREFERENCES.SELECT_CONFIG' | translate"
                            [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                            [clearable]="true"
                            class="form-select">
                        </ng-select>
                    </div>

                    <div class="config-field" *ngIf="showConfig('delfos_llm')">
                        <label>{{ 'SETTINGS.PREFERENCES.DELFOS_LLM' | translate }}</label>
                        <ng-select
                            [(ngModel)]="preferences.default_delfos_llm_config_id"
                            [items]="delfosLlmConfigs"
                            bindLabel="display_label"
                            bindValue="id"
                            [placeholder]="'SETTINGS.PREFERENCES.SELECT_CONFIG' | translate"
                            [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                            [clearable]="true"
                            class="form-select">
                        </ng-select>
                    </div>

                    <div class="config-field" *ngIf="showConfig('di2winocr_server')" [class.disabled]="preferences.use_multimodal">
                        <label>{{ 'SETTINGS.PREFERENCES.OCR_SERVER' | translate }}</label>
                        <ng-select
                            [(ngModel)]="preferences.default_di2winocr_server_config_id"
                            [items]="di2winocrServerConfigs"
                            bindLabel="display_label"
                            bindValue="id"
                            [placeholder]="'SETTINGS.PREFERENCES.SELECT_CONFIG' | translate"
                            [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                            [clearable]="true"
                            [readonly]="preferences.use_multimodal"
                            class="form-select">
                        </ng-select>
                    </div>

                    <div class="config-field" *ngIf="showConfig('di2winocr_features')" [class.disabled]="preferences.use_multimodal">
                        <label>{{ 'SETTINGS.PREFERENCES.OCR_FEATURES' | translate }}</label>
                        <ng-select
                            [(ngModel)]="preferences.default_di2winocr_features_config_id"
                            [items]="di2winocrFeaturesConfigs"
                            bindLabel="display_label"
                            bindValue="id"
                            [placeholder]="'SETTINGS.PREFERENCES.SELECT_CONFIG' | translate"
                            [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                            [clearable]="true"
                            [readonly]="preferences.use_multimodal"
                            class="form-select">
                        </ng-select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #loadingTemplate>
        <div class="loading-message">
            <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
            <span>{{ 'MESSAGE.LOADING' | translate }}</span>
        </div>
    </ng-template>
</div>